import quoteGQLString from '../../util/quoteGQLString';
import { requireFormattedTextFieldValue } from '../../../../../misc/textFieldFormatter';

const cleanDrugDescription = (value) =>
  requireFormattedTextFieldValue(value).replace(
    /[^a-z0-9áéíóúñü .,_-]/gim,
    '',
  );

export default (approval) => `
    id: ${quoteGQLString(approval?.id)}
    org: ${quoteGQLString(approval?.org)}
    fdaApprovalDate: ${quoteGQLString(approval?.fdaApprovalDate)}
    drugDescription: ${quoteGQLString(cleanDrugDescription(approval?.drugDescription))}
`;
